"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var UploadPartCopyInput_1 = require("./UploadPartCopyInput");
var UploadPartCopyOutput_1 = require("./UploadPartCopyOutput");
var ServiceMetadata_1 = require("./ServiceMetadata");
exports.UploadPartCopy = {
    metadata: ServiceMetadata_1.ServiceMetadata,
    name: "UploadPartCopy",
    http: {
        method: "PUT",
        requestUri: "/{Bucket}/{Key+}"
    },
    input: {
        shape: UploadPartCopyInput_1.UploadPartCopyInput
    },
    output: {
        shape: UploadPartCopyOutput_1.UploadPartCopyOutput
    },
    errors: []
};
//# sourceMappingURL=UploadPartCopy.js.map